import {
  getListSubscription, getListVerifyStudent, getListVerifyStudentHistory,
  addSubscriptionPrice, editSubscriptionPrice, deleteSubscriptionPrice,
  getListFirstTimeSubs, getListCancelExpireSubs, getTotalFirstTimeSubs
} from '@/services/subscription';

const getters = {
  list_subscription: state => state.list_subscription,
  list_first_time: state => state.list_first_time,
  list_cancel_expire: state => state.list_cancel_expire,
  list_verify_student: state => state.list_verify_student,
  list_verify_student_history: state => state.list_verify_student_history,
  total_first_time: state => state.total_first_time,
  per_page: state => state.per_page,
};

const actions = {
  async requestListSubscription({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListSubscription({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_SUBSCRIPTION', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddSubscriptionPrice({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addSubscriptionPrice({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListSubscription', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditSubscriptionPrice({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editSubscriptionPrice({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListSubscription', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteSubscriptionPrice({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteSubscriptionPrice({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListSubscription', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListVerifyStudent({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListVerifyStudent({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_VERIFY_STUDENT', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListVerifyStudentHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListVerifyStudentHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_VERIFY_STUDENT_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListFirstTimeSubs({ dispatch, commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      dispatch('requestTotalFirstTimeSubs', filter)
      const response = await getListFirstTimeSubs({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_FIRST_TIME', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestTotalFirstTimeSubs({ commit, rootGetters }, filter) {
    // commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getTotalFirstTimeSubs({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, {
        start_date: filter.start_date,
        end_date: filter.end_date,
      });
      commit('SET_TOTAL_FIRST_TIME', response);
    } catch (err) {
      // commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      // commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListCancelExpireSubs({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListCancelExpireSubs({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_CANCEL_EXPIRE', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_SUBSCRIPTION(state, list_subscription) {
    state.list_subscription = list_subscription;
  },
  SET_LIST_FIRST_TIME(state, list_first_time) {
    state.list_first_time = list_first_time;
  },
  SET_TOTAL_FIRST_TIME(state, total_first_time) {
    state.total_first_time = {
      total_first_time: total_first_time.total_first_time,
      total_free_trial: total_first_time.total_free_trial,
      total_amount: total_first_time.total_amount,
      total_first_time_one_time: total_first_time.total_first_time_one_time,
      total_first_time_recurring: total_first_time.total_first_time_recurring,
    };
  },
  SET_LIST_CANCEL_EXPIRE(state, list_cancel_expire) {
    state.list_cancel_expire = list_cancel_expire;
  },
  SET_LIST_VERIFY_STUDENT(state, list_verify_student) {
    state.list_verify_student = list_verify_student;
  },
  SET_LIST_VERIFY_STUDENT_HISTORY(state, list_verify_student_history) {
    state.list_verify_student_history = list_verify_student_history;
  },
};

export default {
  namespaced: true,
  state: {
    list_subscription: [],
    list_first_time: [],
    list_cancel_expire: [],
    list_verify_student: [],
    list_verify_student_history: [],
    total_first_time: {
      total_first_time: 0,
      total_free_trial: 0,
      total_amount: 0,
      total_first_time_one_time: 0,
      total_first_time_recurring: 0,
    },
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Subscription/index.js